// ============================================================================
// WORKFLOW CONFIG SERVICE (Frontend)
// API calls to the admin workflow config endpoints.
// ============================================================================

import { api } from './api';

export interface WorkflowTrigger {
  type: 'phase_transition' | 'session_start' | 'session_end' | 'timer';
  enabled: boolean;
  config?: {
    intervalMinutes?: number;
    phaseIndexes?: number[];
  };
}

export interface ResolvedWorkflow {
  id: string;
  name: string;
  description: string;
  envVarKey: string;
  availableTriggers: WorkflowTrigger['type'][];
  webhookUrl: string | null;
  webhookUrlSource: 'db' | 'env' | 'unset';
  enabled: boolean;
  triggers: WorkflowTrigger[];
  cinematicView: boolean;
  hasDbOverride: boolean;
}

export const workflowConfigService = {
  async listAll(): Promise<ResolvedWorkflow[]> {
    const { data } = await api.get<{ workflows: ResolvedWorkflow[] }>('/api/admin/workflow-config');
    return data.workflows;
  },

  async get(id: string): Promise<ResolvedWorkflow> {
    const { data } = await api.get<ResolvedWorkflow>(`/api/admin/workflow-config/${id}`);
    return data;
  },

  async update(id: string, patch: { webhookUrl?: string | null; enabled?: boolean; triggers?: WorkflowTrigger[]; cinematicView?: boolean }): Promise<ResolvedWorkflow> {
    const { data } = await api.put<ResolvedWorkflow>(`/api/admin/workflow-config/${id}`, patch);
    return data;
  },

  async reset(id: string): Promise<ResolvedWorkflow> {
    const { data } = await api.post<ResolvedWorkflow>(`/api/admin/workflow-config/${id}/reset`);
    return data;
  },
};
